export default "__VITE_ASSET__0MsjCznY__"